
import React, { useState, useEffect, memo } from "react";

const CountdownTimer = (
    until
) => {


    const [lastUntil, setLastUntil] = useState(until.until + new Date().getTime());
    const [timeRemaining, setTimeRemaining] = useState(0);


    useEffect(() => {
        const countdownInterval = setInterval(() => {
            const currentTime = new Date().getTime();
            const remainingTime = lastUntil - currentTime;

            setTimeRemaining(Math.max(0, remainingTime)); // Clamp to 0
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, [lastUntil]);



    const formatTime = (time) => {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / (1000 * 60)) % 60);
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const days = Math.floor(time / (1000 * 60 * 60 * 24));


        const shouldshowInRed = time < 15 * 60 * 1000; // 15 minutes in milliseconds

        return (
            <> 

                <div className=" mb20 align-items-center d-flex">

                    <div className="cols">
                        <h5 className={`pdp-counter-digits-alert bold text-center mb0 `}>
                            {days.toString().padStart(2, "0")}
                        </h5>
                        <h5 className="pdp-counter-label-alert bold text-center mb0">Days</h5>
                    </div>
                    <h5 className="bold text-center mb0 pdp-counter-dots-alert">:</h5>
                    <div className="cols ">
                        <h5 className={`pdp-counter-digits-alert bold text-center mb0 `}>
                            {hours.toString().padStart(2, "0")}
                        </h5>
                        <h5 className="pdp-counter-label-alert bold text-center mb0">Hours</h5>
                    </div>
                    <h5 className="bold text-center mb0 pdp-counter-dots-alert">:</h5>
                    <div className="cols ">
                        <h5
                            className={`pdp-counter-digits-alert bold text-center mb0 `}
                        >
                            {minutes.toString().padStart(2, "0")}
                        </h5>
                        <h5 className="pdp-counter-label-alert bold text-center mb0">Mins</h5>
                    </div>
                    <h5 className="bold text-center mb0 pdp-counter-dots-alert">:</h5>
                    <div className="cols">
                        <h5 className={`pdp-counter-digits-alert bold text-center mb0 `}>
                            {seconds.toString().padStart(2, "0")}
                        </h5>
                        <h5 className="pdp-counter-label-alert bold text-center mb0">Secs</h5>
                    </div>
                </div></>
        );

    };

    return (
        <div className="countdown-timer-container center">
            {formatTime(timeRemaining)}
        </div>


    );

};

export default memo(CountdownTimer);